import * as Yup from 'yup';

import dayjs from 'dayjs';
import { PassportReqTypes } from '@Enum/api/PassportReqTypes.enum';

export const PassportRequestFormSchema = Yup.object().shape({
  purpose: Yup.string().required('Please choose purpose'),
  remarks: Yup.string().test(
    'If purpose is "Other" remarks field should be required',
    'Please fill remakrs',
    (value, context) => {
      const { purpose } = context.parent;

      if (purpose !== String(PassportReqTypes.OTHER)) {
        return true;
      }

      return !!value;
    }
  ),
  fromDate: Yup.string().required('Please choose From Date'),
  returnDate: Yup.string()
    .required('Please choose Return Date')
    .test(
      'Validate chosen date not less than fromDate',
      'Return day should be NOT less than From date day!',
      (date, context) => {
        const { fromDate } = context.parent;

        if (!fromDate) {
          return true;
        }

        const chosenDateLessThanFromDate =
          dayjs(date).startOf('day') < dayjs(fromDate).startOf('day');

        return !chosenDateLessThanFromDate;
      }
    ),
  totDays: Yup.string(),
});
